import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { AuthShell } from "@/pages/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Lupa kata sandi" subtitle="Kami akan mengirim tautan atur ulang ke email Anda."
      footer={<Link to="/login" className="text-teal font-semibold" data-testid="to-login">Kembali ke masuk</Link>}>
      {sent ? (
        <div data-testid="forgot-success" className="bg-green-50 text-green-800 rounded-xl p-4 flex items-start gap-3">
          <MailCheck className="w-5 h-5 mt-0.5" />
          <p className="text-sm">Jika email terdaftar, tautan atur ulang telah dikirim. Periksa kotak masuk Anda.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          {error && <div className="bg-red-50 text-red-700 text-sm rounded-xl p-3">{error}</div>}
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-xl h-12 mt-1" placeholder="nama@email.com" />
          </div>
          <Button type="submit" data-testid="forgot-submit" disabled={loading} className="w-full h-12 rounded-full bg-teal hover:bg-teal-hover font-semibold">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Kirim Tautan"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
